export const layoutConfig = [
    {
        id: 1,
        i: "welcomeComp",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 10,
    },
    {
        id: 2,
        i: "favoriteLead",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 24,
    },
    {
        id: 3,
        i: "absentees",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 10,
    },
    {
        id: 5,
        i: "activityComponent",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 24,
    },
    {
        id: 6,
        i: "swipeAndIssues",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 24,
    },
    {
        id: 7,
        i: "projectOverviews",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 24,
    },
    {
        id: 8,
        i: "leadPotential",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 9,
        i: "documentApproval",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 25,
    },
    {
        id: 10,
        i: "generalTask",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 28,
    },
    {
        id: 11,
        i: "appliedLeaves",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 24,
        maxW: 12,
    },
    {
        id: 12,
        i: "workduration",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 10,
    },
    {
        id: 13,
        i: "gitPush",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 10,
    },
    {
        id: 14,
        i: "clearlogin",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 10,
    },
    {
        id: 15,
        i: "flawGap",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 10,
    },
    {
        id: 16,
        i: "notify",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
    },
    {
        id: 17,
        i: "flawList",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 18,
        i: "overdraft",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 19,
        i: "timerApproval",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 20,
        i: "projectTickets",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 21,
        i: "inTestingProjects",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 22,
        i: "queriesTicket",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 23,
        i: "earthTickets",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 24,
        i: "estimatedSalary",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 25,
        i: "pendingInvoice",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 26,
        i: "pastSixLeaves",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 27,
        i: "workingHours",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 28,
        i: "versionControl",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 30,
        i: "salesReportInd",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 32,
        i: "codeQueries",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 33,
        i: "currentProjectTimer",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 34,
        i: "allProject",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 35,
        i: "workLoadReport",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 36,
        i: "overallWork",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 38,
        i: "introducerCommission",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 39,
        i: "pendingLeaves",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 40,
        i: "punchApproval",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 41,
        i: "myPunchLog",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 42,
        i: "developTodayTime",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 43,
        i: "leaveReport",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 44,
        i: "seoReportApproval",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 45,
        i: "hostingDatas",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 46,
        i: "linkedinReport",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
    {
        id: 47,
        i: "projection",
        x: 0,
        y: 0,
        w: 3,
        h: 8,
        minW: 1,
        minH: 2,
        maxH: 40,
    },
]

export const calculateLayout = layoutConfigs => {
    let updatedLayout = [...layoutConfigs]
    let lastX = 0
    let lastY = 0

    updatedLayout.forEach((item, index) => {
        if (index > 0) {
            if (lastX + item.w > 12) {
                lastX = 0
                lastY += item.h
            }
            item.x = lastX
            item.y = lastY

            lastX += item.w
        } else {
            item.x = 0
            item.y = 0
            lastX = item.w
        }
    })

    return updatedLayout
}

export const allElements = [
    {
        name: "Sales",
        id: 1,
        inner: [
            {
                id: 2,
                name: "Favorite Leads",
                checked: false,
            },
            {
                id: 8,
                name: "Lead Potentials",
                checked: false,
            },
            {
                id: 30,
                name: "Sales Report Uk",
                checked: false,
            },
            {
                id: 46,
                name: "LinkedIn Report",
                checked: false,
            },

        ],
    },
    {
        name: "Human Resources",
        id: 2,
        inner: [
            {
                id: 1,
                name: "Profile",
                checked: false,
            },
            {
                id: 3,
                name: "Absentees",
                checked: false,
            },
            {
                id: 9,
                name: "Document Approvel",
                checked: false,
            },
            {
                id: 6,
                name: "Swipe & Issues",
                checked: false,
            },
            {
                id: 11,
                name: "Leaves Approval",
                checked: false,
            },
            {
                id: 14,
                name: "Clear Login",
                checked: false,
            },
            {
                id: 15,
                name: "Flaws & Gaps",
                checked: false,
            },
            {
                id: 17,
                name: "F&Gs List",
                checked: false,
            },
            {
                id: 24,
                name: "Estimated Salary",
                checked: false,
            },
            {
                id: 25,
                name: "Pending Invoice",
                checked: false,
            },
            {
                id: 26,
                name: "Past Six Month Leaves",
                checked: false,
            },
            {
                id: 27,
                name: "Working Hours",
                checked: false,
            },
            {
                id: 39,
                name: "Pending Leaves",
                checked: false,
            },
            {
                id: 40,
                name: "Punch Approval",
                checked: false,
            },
            {
                id: 41,
                name: "My Punch logs",
                checked: false,
            },
            {
                id: 43,
                name: "Leave Report",
                checked: false,
            },

        ],
    },
    {
        name: "Support",
        id: 6,
        inner: [
            {
                id: 22,
                name: "Queries Tickets",
                checked: false,
            },
            {
                id: 23,
                name: "Earth ZAI Tickets",
                checked: false,
            },
            {
                id: 32,
                name: "Code Review Queries",
                checked: false,
            },
        ],
    },
    {
        name: "Work",
        id: 3,
        inner: [
            {
                id: 10,
                name: "My Activity",
                checked: false,
            },
            {
                id: 5,
                name: "Teams Activity",
                checked: false,
            },
            {
                id: 12,
                name: "Work Duration",
                checked: false,
            },
            {
                id: 13,
                name: "Git Pushed Pending",
                checked: false,
            },
            {
                id: 19,
                name: "Timer Approval",
                checked: false,
            },
            {
                id: 7,
                name: "Project Overview",
                checked: false,
            },
            {
                id: 20,
                name: "Project Coins",
                checked: false,
            },
            {
                id: 21,
                name: "QA Task Allotment",
                checked: false,
            },
            {
                id: 33,
                name: "Current Project Timers ",
                checked: false,
            },
            {
                id: 34,
                name: "All Projects",
                checked: false,
            },
            {
                id: 35,
                name: "Work Load Report",
                checked: false,
            },
            {
                id: 36,
                name: "Overall Today's Work",
                checked: false,
            },
            {
                id: 42,
                name: "Developer Today's Work",
                checked: false,
            },
            {
                id: 44,
                name: "SEO Report Approval",
                checked: false,
            },
            {
                id: 45,
                name: "Hosting",
                checked: false,
            },
        ],
    },
    {
        name: "Settings",
        id: 4,
        inner: [
            {
                id: 16,
                name: "Notifications",
                checked: false,
            },
            {
                id: 28,
                name: "Version Control",
                checked: false,
            },
        ],
    },
    {
        name: "Finance",
        id: 5,
        inner: [
            {
                id: 1,
                name: "Profile",
                checked: false,
            },
            {
                id: 18,
                name: "Overdraft Report",
                checked: false,
            },
            {
                id: 25,
                name: "Pending Invoice",
                checked: false,
            },
            {
                id: 38,
                name: "Introducer Commission",
                checked: false,
            },
            {
                id: 47,
                name: "Projection Current Finance",
                checked: false
            }
        ],
    },
]